import { defineStore } from 'pinia';
import { useToast } from 'vue-toast-notification';

import '@/scss/lib/vue-toast.scss';

const toast = useToast({
  position: 'top-right',
});

const errorToastConfig = {
  duration: 6000,
  dismissible: true,
};

const useToastStore = defineStore('toast', {
  actions: {
    showMessage(payload) {
      const { type, message } = payload;
      if (message) {
        switch (type) {
          case 'error':
            toast.error(message, errorToastConfig);
            break;
          default:
            toast.success(message);
        }
      }
    },
  },
});

export default useToastStore;
